import * as C from '../constants';
import xmlStatsService from '../../../services/xml-stats-service';

export default {
  /**
   * @param commit
   * @param payload
   */
  getChannels({ commit }) {
    commit(C.PRICES_CHANNEL_LIST_PENDING);
    xmlStatsService.getChannels({})
      .then((res) => {
        if (res.status === 200) {
          res.data.sort((a, b) => (a.webservice > b.webservice ? 1 : -1));
          commit(C.PRICES_CHANNEL_LIST_SUCCESS, res.data);
        } else {
          commit(C.PRICES_CHANNEL_LIST_NO_CONTENT);
        }
      })
      .catch((error) => {
        commit(C.PRICES_CHANNEL_LIST_FAILURE, error);
      });
  },
  /**
   * @param commit
   * @param params
   * @param payload
   */
  getPricesImport({ commit }, params) {
    const xmlJobId = params.xmlJobId;
    const filters = params.filters;
    commit(C.PRICES_IMPORT_LIST_PENDING);
    xmlStatsService.getPricesImport(xmlJobId, filters)
      .then((res) => {
        if (res.status === 200) {
          commit(C.PRICES_IMPORT_LIST_SUCCESS, res.data);
        } else {
          commit(C.PRICES_IMPORT_LIST_NO_CONTENT);
        }
      })
      .catch((error) => {
        commit(C.PRICES_IMPORT_LIST_FAILURE, error);
      });
  },
  /**
   * @param commit
   * @param params
   * @param payload
   */
  getPricesPush({ commit }, params) {
    const xmlChannelProductId = params.xmlChannelProductId;
    const filters = params.filters;
    commit(C.PRICES_PUSH_LIST_PENDING);
    xmlStatsService.getPricesPush(xmlChannelProductId, filters)
      .then((res) => {
        if (res.status === 200) {
          commit(C.PRICES_PUSH_LIST_SUCCESS, res.data);
        } else {
          commit(C.PRICES_PUSH_LIST_NO_CONTENT);
        }
      })
      .catch((error) => {
        commit(C.PRICES_PUSH_LIST_FAILURE, error);
      });
  },
  /**
   * @param commit
   * @param channelId
   * @param payload
   */
  getJobs({ commit }, channelId) {
    commit(C.PRICES_JOB_LIST_PENDING);
    xmlStatsService.getXmlJobs(channelId)
      .then((res) => {
        if (res.status === 200) {
          commit(C.PRICES_JOB_LIST_SUCCESS, res.data);
        } else {
          commit(C.PRICES_JOB_LIST_NO_CONTENT);
        }
      })
      .catch((error) => {
        commit(C.PRICES_JOB_LIST_FAILURE, error);
      });
  },
  /**
   * @param commit
   * @param channelIds
   * @param payload
   */
  getChannelProducts({ commit }, channelIds) {
    commit(C.PRICES_CHANNEL_PRODUCTS_LIST_PENDING);
    xmlStatsService.getChannelProducts(channelIds)
      .then((res) => {
        if (res.status === 200) {
          commit(C.PRICES_CHANNEL_PRODUCTS_LIST_SUCCESS, res.data);
        } else {
          commit(C.PRICES_CHANNEL_PRODUCTS_LIST_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.PRICES_CHANNEL_PRODUCTS_LIST_FAILURE);
      });
  },
  /**
   * @param commit
   * @param channel
   * @param payload
   */
  selectChannel({ commit }, channel) {
    commit(C.PRICES_SET_CHANNEL, channel);
  },
  /**
   * @param commit
   * @param type
   * @param payload
   */
  selectType({ commit }, type) {
    commit(C.PRICES_SET_TYPE, type);
  },
  /**
   * @param commit
   */
  clearChannel({ commit }) {
    commit(C.PRICES_CLEAR_CHANNEL);
  },
  /**
   * @param commit
   */
  clearType({ commit }) {
    commit(C.PRICES_CLEAR_TYPE);
  },
  /**
   * @param commit
   */
  resetPricesList({ commit }) {
    commit(C.PRICES_LIST_RESET);
  },
  /**
   * @param commit
   */
  clearState({ commit }) {
    commit(C.PRICES_CLEAR_STATE);
  },
  /**
   * @param commit
   */
  updatePricesPaginationIndex({ commit }) {
    commit(C.PRICES_UPDATE_PAGINATION_INDEX);
  },
  /**
   * @param commit
   */
  resetPricesPaginationIndex({ commit }) {
    commit(C.PRICES_RESET_PAGINATION_INDEX);
  },
  /**
   * @param commit
   */
  pricesLoadNewPage({ commit }) {
    commit(C.PRICES_LOAD_NEW_PAGE);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/prices/actions.js